// extracted by mini-css-extract-plugin
export var statItem = "_mi-1";
export var statsRow = "_mi-0";